import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CommandEnum } from 'src/app/models/common/enums/command.enum';
import { AlertService } from 'src/app/services/common/alert.service';
import { CommandService } from 'src/app/services/common/command.service';
import { AccountService } from 'src/app/services/user/account.service';

@Component({
    selector: 'user-email-us',
    templateUrl: './email-us.component.html',
    styleUrls: ['./email-us.component.scss'],
    standalone: false
})
export class EmailUsComponent implements OnInit {
  formSubmitted = false;
  error: string;
  @Output() onEmailSend: EventEmitter<boolean> = new EventEmitter<boolean>();

  emailForm = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    phone: new UntypedFormControl('', [Validators.pattern('^(\\+?\\d{10,14}|\\d{9,12})$')]),
    message: new UntypedFormControl('', [Validators.required, Validators.maxLength(1000)])
  });

  constructor(
    private commandService: CommandService, 
    private alertService: AlertService,
    private accountService: AccountService
    ) { }

  ngOnInit(): void {
  }

  getFieldFromForm(fieldName: string) {
    return this.emailForm.get(fieldName);
  }

  onFormSubmit() {
    if (!this.formSubmitted) {
      this.formSubmitted = true;
    this.accountService.helpEmail(this.emailForm.value)
    .then(response => this.onEmailSend.emit(true))
    .catch((err) => {
      this.error = err.error.error;
      this.alertService.showError(this.error);
    });
  }
}
}
